import { z } from 'zod';

export const jobArchitectureOptionsResponseSchema = z.object({
    canCreate: z.boolean(),
    canRead: z.boolean(),
});

export type JobArchitectureOptionsResponse = z.infer<typeof jobArchitectureOptionsResponseSchema>;

export const jobArchitecturePermissionsSchema = jobArchitectureOptionsResponseSchema.transform((value) => ({
    canUserCreateJobArchitecture: value.canCreate,
    canUserGetJobArchitecture: value.canRead,
}));

export type JobArchitecturePermissions = z.infer<typeof jobArchitecturePermissionsSchema>;

export const jobArchitectureInflightSchema = z.object({
    clusterGenerations: z.number(),
    clusterTranslations: z.number(),
    familyGenerations: z.number(),
    familyTranslations: z.number(),
    hasTasksInFlight: z.boolean(),
    jobArchitectureId: z.string(),
    levelGenerations: z.number(),
    levelTranslations: z.number(),
    roleGenerations: z.number(),
    roleTranslations: z.number(),
    skillDetections: z.number(),
    totalInFlight: z.number(),
});

export type JobArchitectureInflight = z.infer<typeof jobArchitectureInflightSchema>;

export const jobArchitecturePathSchema = z.object({
    cluster: z.string().nullish(),
    family: z.string().nullish(),
    level: z.string().nullish(),
    role: z.string().nullish(),
});

export type JobArchitecturePath = z.infer<typeof jobArchitecturePathSchema>;
